import axios from 'axios';


const instance = axios.create({
    baseURL : "https://newlookmechanical.herokuapp.com/"
})

export default instance;
